export default __webpack_public_path__ + "static/media/bg-valdano-bio-02@2x.c056f141.jpg";